<div class="card">
  <div class="card-title">
    <span>Advanced Data Explorer</span>
    <span *ngIf="isLoading" class="loader-sm" style="margin-left:10px;"></span>
  </div>

  <div style="margin-bottom: 16px; display: flex; gap: 12px; flex-wrap: wrap; align-items: center;">
    <label style="font-size:12px; font-weight:700; color:var(--text-muted);">Record Type:</label>
    <select [(ngModel)]="lmsFlagFilter" (change)="handleFilterChange()"
      style="padding: 8px 12px; border-radius: 8px; border: 1px solid var(--border); font-size: 13px;">
      <option value="-1">All Records</option>
      <option value="1">Approved</option>
      <option value="0">Pending</option>
      <option value="2">Rejected</option>
      <option value="4">Resolved</option>
    </select>

    <input type="text" [(ngModel)]="explorerSearch" (input)="handleSearchChange()"
      placeholder="Filter by Name, NDA or NDC..."
      style="padding: 8px 12px; border-radius: 8px; border: 1px solid var(--border); font-size: 13px; flex: 1;">

    <select [(ngModel)]="statusFilter" (change)="handleFilterChange()"
      style="padding: 8px 12px; border-radius: 8px; border: 1px solid var(--border); font-size: 13px;">
      <option value="">All Statuses</option>
      <option value="Current">Current</option>
      <option value="To Be Discontinued">To Be Discontinued</option>
      <option value="Resolved">Resolved</option>
    </select>

    <select [(ngModel)]="updateFilter" (change)="handleFilterChange()"
      style="padding: 8px 12px; border-radius: 8px; border: 1px solid var(--border); font-size: 13px;">
      <option value="">All Updates</option>
      <option value="New">New</option>
      <option value="Revised">Revised</option>
      <option value="Reverified">Reverified</option>
    </select>

    <select [(ngModel)]="routeFilter" (change)="handleFilterChange()"
      style="padding: 8px 12px; border-radius: 8px; border: 1px solid var(--border); font-size: 13px;">
      <option value="">All Routes</option>
      <option *ngFor="let route of routeOptions" [value]="route">{{route}}</option>
    </select>
  </div>

  <div class="table-wrap" [class.loading-opacity]="isLoading">
    <table>
      <thead>
        <tr>
          <th>NDA Number</th>
          <th>Brand Name</th>
          <th>Route</th>
          <th>Dosage Form</th>
          <th>NDC Count</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of filteredData">
          <td>{{d.nda || 'N/A'}}</td>
          <td><b>{{d.brand_name || 'N/A'}}</b></td>
          <td>{{(d.ndcs && d.ndcs.length > 0 ? d.ndcs[0].sub_route : 'N/A')}}</td>
          <td>{{d.summary?.dosage_forms?.join(', ') || d.dosage_forms || 'N/A'}}</td>
          <td style="min-width: 150px;">
            <span style="color: var(--primary); font-size: 11px; font-weight: 700;">{{d.ndcs?.length || 0}} NDC{{(d.ndcs?.length || 0) > 1 ? 's' : ''}}</span>
          </td>
          <td style="min-width: 160px;">
            <div style="display: flex; gap: 8px; align-items: center;">
              <button (click)="onOpenDetail(d)"
                style="padding: 4px 12px; font-size: 11px; font-weight: 600; border-radius: 6px; border: 1px solid var(--primary); background: transparent; color: var(--primary); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; height: 26px; transition: all 0.2s;">Details</button>
            </div>
          </td>
        </tr>
        <tr *ngIf="filteredData.length === 0 && !isLoading">
          <td colspan="6" style="text-align:center; padding: 40px; color: var(--text-muted);">No records found matching
            filters.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- PAGINATION -->
  <div class="pagination-footer" *ngIf="totalPages > 0">
    <div class="pagination-controls">
      <button (click)="goToPage(1)" [disabled]="currentPage === 1" class="page-btn symbol" title="First Page">«</button>
      <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1" class="page-btn symbol"
        title="Previous">‹</button>

      <button *ngFor="let p of getVisiblePages()" (click)="goToPage(p)" class="page-btn"
        [class.active]="p === currentPage">
        {{p}}
      </button>

      <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages" class="page-btn symbol"
        title="Next">›</button>
      <button (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages" class="page-btn symbol"
        title="Last Page">»</button>

      <select [(ngModel)]="pageSize" (change)="handlePageSizeChange()" class="page-size-select">
        <option [value]="10">10</option>
        <option [value]="20">20</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select>
    </div>

    <div class="total-records">
      Total Records : {{totalRecords | number}}
    </div>
  </div>
</div>

<!-- DETAIL MODAL -->
<div *ngIf="showModal && selectedProduct" class="modal-overlay" (click)="closeModal()">
  <div class="modal-card modal-card-lg" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 style="margin: 0; color:var(--primary); font-size: 22px; font-weight: 600;">Product Details</h2>
      <button class="modal-close-btn" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px 40px; margin-bottom: 30px;">
        <div>
          <div
            style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
            NDA</div>
          <div style="font-weight: 700; font-size: 15px; color: #334155;">{{selectedProduct.nda}}</div>
        </div>
        <div>
          <div
            style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
            Brand Name</div>
          <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
            {{selectedProduct.brand_name || 'N/A'}}</div>
        </div>
        <div>
          <div
            style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
            Route</div>
          <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
            {{(selectedProduct.ndcs && selectedProduct.ndcs.length > 0 ? selectedProduct.ndcs[0].sub_route : 'N/A')}}
          </div>
        </div>
        <div>
          <div
            style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
            Dosage Form</div>
          <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
            {{selectedProduct.summary?.dosage_forms?.join(', ') || selectedProduct.dosage_forms || 'N/A'}}</div>
        </div>
      </div>

      <div style="border-top:1px solid #f1f5f9; padding-top:24px;">
        <h3 style="font-size:15px; margin-bottom:16px; font-weight: 700; color: #334155;">NDCs</h3>

        <div class="company-tiles-container" *ngIf="getUniqueCompanies().length > 0">
          <div class="company-tile" [class.active]="selectedCompanyFilter === 'ALL'"
            (click)="selectedCompanyFilter = 'ALL'">
            <div class="tile-title">ALL</div>
            <div class="tile-count">{{selectedProduct?.ndcs?.length || 0}} NDCs</div>
          </div>
          <div *ngFor="let company of getUniqueCompanies()" class="company-tile"
            [class.active]="selectedCompanyFilter === company" (click)="selectedCompanyFilter = company">
            <div class="tile-title" [title]="company">{{company}}</div>
            <div class="tile-count">{{getNdcCountForCompany(company)}} NDC{{getNdcCountForCompany(company) !== 1 ? 's' :
              ''}}</div>
          </div>
        </div>

        <div class="ndc-list">
          <div *ngFor="let ndcItem of getNdcsForSelectedProduct()" class="ndc-list-item"
            style="border: 1px solid #eef2f6; border-radius: 12px; margin-bottom: 12px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.02);">
            <!-- Collapsible Header -->
            <div (click)="toggleNdcExpand(ndcItem.ndc)"
              style="background: #f8fafc; padding: 14px 20px; display: flex; justify-content: space-between; align-items: center; cursor: pointer;">
              <div style="display: flex; gap: 24px; align-items: center; flex-wrap: wrap;">
                <div>
                  <span
                    style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; display: block; margin-bottom: 2px;">NDC
                    Number</span>
                  <span style="font-weight: 700; font-size: 14px; color: #334155;">{{ndcItem.ndc}}</span>
                </div>
                <div>
                  <span
                    style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; display: block; margin-bottom: 2px;">Strength</span>
                  <span style="font-weight: 700; font-size: 14px; color: #334155;">{{ndcItem.strength || 'N/A'}}</span>
                </div>
              </div>
              <div style="display: flex; align-items: center; gap: 12px;">
                <span [style.color]="getVal(ndcItem.latest_record?.status) === 'Current' ? '#2563eb' : 'var(--primary)'"
                  style="font-size: 11px; font-weight: 700;">
                  {{getVal(ndcItem.latest_record?.status)}}
                </span>
                <i class="pi" [ngClass]="expandedNdcs[ndcItem.ndc] ? 'pi-chevron-up' : 'pi-chevron-down'"
                  style="font-size: 14px; color: #64748b;"></i>
              </div>
            </div>

            <!-- Expanded Detail Section -->
            <div *ngIf="expandedNdcs[ndcItem.ndc]"
              style="padding: 20px; background: #fff; border-top: 1px solid #eef2f6;">
              <div
                style="display: flex; justify-content: space-between; align-items: center; margin-bottom:16px; flex-wrap: wrap; gap: 12px;">
                <h4
                  style="font-weight:700; font-size: 16px; color:var(--primary); margin:0; display: inline-flex; align-items: center;">
                  {{getVal(ndcItem.latest_record?.company_name)}}
                  <button type="button" (click)="openFieldChanges(ndcItem, 'company_name', 'Company Name', $event)"
                    title="View company name history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); margin-left: 6px; display: inline-flex; align-items: center;">
                    <i class="pi pi-info-circle" style="font-size: 14px;"></i>
                  </button>
                </h4>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="font-size: 13px; color: #64748b;">Date of Update:</span>
                  <span style="color: #2563eb; font-size: 11px; font-weight: 700;">
                    {{getFormattedDate(ndcItem.latest_record?.date_of_update)}}
                  </span>
                  <button type="button" (click)="openFieldChanges(ndcItem, 'date_of_update', 'Date of Update', $event)"
                    title="View update date history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); display: inline-flex; align-items: center;">
                    <i class="pi pi-info-circle" style="font-size: 13px;"></i>
                  </button>
                </div>
              </div>

              <div
                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px 32px; margin-bottom: 20px; font-size: 13px;">
                <div style="display: flex; align-items: center; flex-wrap: wrap;">
                  <span style="font-weight:700; color: #334155;">Status:</span>
                  <span style="color: #475569; margin-left:6px;">{{getVal(ndcItem.latest_record?.status)}}</span>
                  <button type="button" (click)="openFieldChanges(ndcItem, 'status', 'Status', $event)"
                    title="View status history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); display: inline-flex; align-items: center; margin-left: 4px;">
                    <i class="pi pi-info-circle" style="font-size: 13px;"></i>
                  </button>
                </div>
                <div style="display: flex; align-items: center; flex-wrap: wrap;">
                  <span style="font-weight:700; color: #334155;">Update Type:</span>
                  <span
                    style="color: #475569; margin-left:6px;">{{getVal(ndcItem.latest_record?.type_of_update)}}</span>
                  <button type="button" (click)="openFieldChanges(ndcItem, 'type_of_update', 'Update Type', $event)"
                    title="View update type history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); display: inline-flex; align-items: center; margin-left: 4px;">
                    <i class="pi pi-info-circle" style="font-size: 13px;"></i>
                  </button>
                </div>
                <div style="display: flex; align-items: center; flex-wrap: wrap;">
                  <span style="font-weight:700; color: #334155;">Date of Discontinued:</span>
                  <span
                    style="color: #475569; margin-left:6px;">{{getFormattedDate(ndcItem.latest_record?.date_discontinued)}}</span>
                  <button type="button"
                    (click)="openFieldChanges(ndcItem, 'date_discontinued', 'Date of Discontinued', $event)"
                    title="View discontinued date history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); display: inline-flex; align-items: center; margin-left: 4px;">
                    <i class="pi pi-info-circle" style="font-size: 13px;"></i>
                  </button>
                </div>
                <div style="display: flex; align-items: center; flex-wrap: wrap;">
                  <span style="font-weight:700; color: #334155;">Initial Posting Date:</span>
                  <span
                    style="color: #475569; margin-left:6px;">{{getFormattedDate(ndcItem.latest_record?.initial_posting_date)}}</span>
                  <button type="button"
                    (click)="openFieldChanges(ndcItem, 'initial_posting_date', 'Initial Posting Date', $event)"
                    title="View initial posting date history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); display: inline-flex; align-items: center; margin-left: 4px;">
                    <i class="pi pi-info-circle" style="font-size: 13px;"></i>
                  </button>
                </div>
                <div *ngIf="isPending(ndcItem)">
                  <span style="font-weight:700; color: #334155;">Action:</span>
                  <span style="margin-left: 6px; display: inline-block; vertical-align: middle;">
                    <button (click)="onRerun(ndcItem)" class="badge badge-green"
                      style="border: none; cursor: pointer; padding: 4px 10px; border-radius: 6px;"
                      [disabled]="ndcItem.isRerunning">
                      <span *ngIf="!ndcItem.isRerunning">Rerun</span>
                      <span *ngIf="ndcItem.isRerunning" class="loader-sm"
                        style="width: 10px; height: 10px; border-width: 1px; display: inline-block;"></span>
                    </button>
                  </span>
                </div>
              </div>

              <div style="font-size: 13px; padding-top: 16px; border-top: 1px solid #eef2f6;">
                <div style="margin-bottom: 8px; display: flex; align-items: center; flex-wrap: wrap;">
                  <span style="font-weight: 700; color: #334155;">Reason of Shortage:</span>
                  <span
                    style="color: #64748b; margin-left: 6px;">{{getVal(ndcItem.latest_record?.reason_for_shortage)}}</span>
                  <button type="button"
                    (click)="openFieldChanges(ndcItem, 'reason_for_shortage', 'Reason of Shortage', $event)"
                    title="View reason of shortage history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); display: inline-flex; align-items: center; margin-left: 4px;">
                    <i class="pi pi-info-circle" style="font-size: 13px;"></i>
                  </button>
                </div>
                <div style="display: flex; align-items: center; flex-wrap: wrap;">
                  <span style="font-weight: 700; color: #334155;">Related Information:</span>
                  <span
                    style="color: #64748b; margin-left: 6px;">{{getVal(ndcItem.latest_record?.related_information)}}</span>
                  <button type="button"
                    (click)="openFieldChanges(ndcItem, 'related_information', 'Related Information', $event)"
                    title="View related information history"
                    style="background: none; border: none; padding: 2px; cursor: pointer; color: var(--primary); display: inline-flex; align-items: center; margin-left: 4px;">
                    <i class="pi pi-info-circle" style="font-size: 13px;"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FIELD CHANGES HISTORY MODAL -->
<div class="modal-overlay" *ngIf="showFieldChangesModal" (click)="closeFieldChangesModal()">
  <div class="modal-card" (click)="$event.stopPropagation()" style="max-width: 550px;">
    <div class="modal-header">
      <h3 style="margin: 0; color:var(--primary); font-size: 18px; font-weight: 600; text-transform: capitalize;">
        {{selectedFieldName}} Changes History
      </h3>
      <button class="modal-close-btn" (click)="closeFieldChangesModal()">&times;</button>
    </div>
    <div class="modal-body">
      <div style="font-size: 12px; color: var(--text-muted); margin-bottom: 16px;">
        NDC: <b>{{selectedFieldNdc}}</b>
      </div>

      <div style="max-height: 300px; overflow-y: auto; border: 1px solid #f1f5f9; border-radius: 8px;">
        <table class="modal-table" style="width: 100%; border-collapse: collapse; text-align: left; font-size: 13px;">
          <thead>
            <tr style="background: #f8fafc; border-bottom: 1px solid #e2e8f0; color: #475569; font-weight: 600;">
              <th style="padding: 10px 12px;">Changed At</th>
              <th style="padding: 10px 12px;">Old Value</th>
              <th style="padding: 10px 12px;">New Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let change of selectedFieldChanges" style="border-bottom: 1px solid #f1f5f9; color: #334155;">
              <td style="padding: 10px 12px; font-weight: 500;">
                {{getFormattedDate(change.changed_at) || getFormattedDate(change.date)}}
              </td>
              <td style="padding: 10px 12px;">
                <span
                  style="color: #b91c1c; font-size: 12px; font-family: monospace; display: inline-block; word-break: break-all;">
                  {{getVal(change.old_value)}}
                </span>
              </td>
              <td style="padding: 10px 12px;">
                <span
                  style="color: #15803d; font-size: 12px; font-family: monospace; font-weight: 600; display: inline-block; word-break: break-all;">
                  {{getVal(change.new_value)}}
                </span>
              </td>
            </tr>
            <tr *ngIf="selectedFieldChanges.length === 0">
              <td colspan="3" style="text-align: center; padding: 30px; color: #94a3b8;">
                No changes history recorded for this field.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="display: flex; justify-content: flex-end; margin-top: 24px;">
        <button class="btn btn-secondary" (click)="closeFieldChangesModal()"
          style="padding: 8px 20px; font-size: 13px; font-weight: 600; border-radius: 6px; border: 1px solid #cbd5e1; background: #fff; color: #475569; cursor: pointer; transition: all 0.2s;">Close</button>
      </div>
    </div>
  </div>
</div>